import './Contact.css';
import { useEffect } from 'react';
import profilePic from './IMAGE/CHRIS.jpeg';

function Contact({ onNavigateHome }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="contact-page">
      <main className="contact-main">
        <div className="contact-bg-orb contact-bg-orb-left"></div>
        <div className="contact-bg-orb contact-bg-orb-right"></div>
        <div className="contact-card">
          <div className="contact-photo-pane">
            <img src={profilePic} alt="Christian Kalaw" className="contact-photo" />
          </div>

          <div className="contact-content-pane">
            <p className="contact-label">Professional Contact</p>
            <h1>Contact Information</h1>
            <p className="contact-subtitle">
              I am currently open for future inquiries, project collaborations, and career opportunities.
            </p>

            <div className="contact-divider"></div>

            <div className="contact-list">
              <a href="mailto:christiankalaw@gmail.com" className="contact-item">
                <span className="contact-item-label">Email</span>
                <span className="contact-item-value">christiankalaw@gmail.com</span>
              </a>
              <a href="https://www.linkedin.com/in/christian-kalaw-590b29357/" target="_blank" rel="noreferrer" className="contact-item">
                <span className="contact-item-label">LinkedIn</span>
                <span className="contact-item-value">www.linkedin.com/in/christian-kalaw-590b29357</span>
              </a>
              <div className="contact-item">
                <span className="contact-item-label">Phone</span>
                <span className="contact-item-value">+63 912 345 6789</span>
              </div>
              <div className="contact-item">
                <span className="contact-item-label">Location</span>
                <span className="contact-item-value">Lipa City, Batangas</span>
              </div>
            </div>

            <p className="contact-message">
              Feel free to reach out and I will respond as soon as possible.
            </p>
          </div>
        </div>
      </main>
      <footer className="contact-footer">
        <p>Christian D. Kalaw &copy; {new Date().getFullYear()}</p>
        <button className="contact-footer-back" onClick={onNavigateHome}>Back to Portfolio</button>
      </footer>
    </div>
  );
}

export default Contact;
